import { useEffect, useState } from 'react'
import { Select } from 'mk-pc'
import { getAppList } from '@/features/application'
import './index.scss'

type BaseAppSelectorProps = {
  value?: string | number
  style?: React.CSSProperties
  onChange: (e: string) => void
}

/**
 * 应用选择
 * @returns
 */
export const AppSelector: React.FC<Partial<BaseAppSelectorProps>> = (props) => {
  const { style = {}, value, onChange } = props
  const [options, setOptions] = useState()

  useEffect(() => {
    fetchList()
  }, [])

  /**
   * 获取列表数据
   */
  const fetchList = async () => {
    const result = await getAppList()
    setOptions(result)
  }

  const handleChange = (e: string) => {
    if (onChange) {
      onChange(e)
    }
  }

  return (
    <section className="app-selector">
      <Select
        allowClear
        value={value}
        style={{ width: '100%', ...style }}
        fieldNames={{ label: 'name', value: 'id' }}
        onChange={handleChange}
        placeholder="选择应用"
        options={options}
      />
    </section>
  )
}
